import {
  EventModelAsStudent,
  TagModel
} from 'front-end/src/graphql/private/PrivateSchemaTypes'
import React from 'react'
import dayjs from 'shared/dayjs'
import {
  useEventsTagPageAsAsAdminQuery,
  useEventsTagPageAsStudentQuery
} from './EventsTagPage.codegen'

import EventsTagPagePresentation from './EventsTagPagePresentation'

interface IParams {
  tagId: number
}

export const EventsTagPageAsAdmin: React.FC<IParams> = (props) => {
  const { data, loading } = useEventsTagPageAsAsAdminQuery({
    variables: {
      tagId: props.tagId,
      tagIdAsJson: props.tagId,
      endingFrom: dayjs().startOf('minute').toISOString()
    }
  })

  return (
    <EventsTagPagePresentation
      events={
        data?.admin?.organisation?.events as any as Array<
          Partial<EventModelAsStudent>
        >
      }
      tag={data?.admin?.organisation?.tag as TagModel}
      loading={loading}
    />
  )
}

export const EventsTagPageAsStudent: React.FC<IParams> = (props) => {
  const { data, loading } = useEventsTagPageAsStudentQuery({
    fetchPolicy: 'cache-first',
    variables: {
      tagId: props.tagId,
      endingFrom: dayjs().startOf('minute').toISOString()
    }
  })

  return (
    <EventsTagPagePresentation
      events={data?.events as any as Array<Partial<EventModelAsStudent>>}
      tag={data?.tag as TagModel}
      loading={loading}
    />
  )
}
